'productCategory'.datatype({source: 'WC'})
'productId'.field({key: true, numeric: true, nonUnique: true})
'categoryId'.field({numeric: true})

'productCategory'.method('toCategory', async function() {
  return await 'category'.bringFirst({id: this.categoryId})
})
